export enum ContainerBatteryStatusEnum {
    NoInfo = 0,
    Normal = 1,
    Low = 2,
    Critical = 3
}